import preferredLaneTypes from './preferredLanesTypes'

export const initialState = {
  preferredLanes: [],
  fethLoading: false,
  preferredLanesAlreadyLoaded: false,
  fethError: '',
  addLoading: false,
  addError: '',
  editLoading: false,
  editError: '',
  deleteLoading: false,
  deleteError: ''
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case preferredLaneTypes.GET_PREFERRED_LANES:
      return {
        ...state,
        fethLoading: true,
        fethError: '',
        preferredLanes: []
      }

    case preferredLaneTypes.GET_PREFERRED_LANES_SUCCESS:
      return {
        ...state,
        fethLoading: false,
        fethError: '',
        preferredLanes: payload,
        preferredLanesAlreadyLoaded: true
      }

    case preferredLaneTypes.GET_PREFERRED_LANES_FAILURE:
      return {
        ...state,
        fethLoading: false,
        fethError: payload
      }

    case preferredLaneTypes.ADD_PREFERRED_LANE:
      return {
        ...state,
        addLoading: true,
        addError: ''
      }

    case preferredLaneTypes.ADD_PREFERRED_LANE_SUCCESS: {
      const newLane = {
        ...payload,
        origin: {
          ...payload.origin,
          state_code: payload.origin.state_id
        },
        destination: {
          ...payload.destination,
          state_code: payload.destination.state_id
        }
      }
      return {
        ...state,
        preferredLanes: [newLane, ...state.preferredLanes],
        addLoading: false,
        addError: ''
      }
    }

    case preferredLaneTypes.ADD_PREFERRED_LANE_FAILURE:
      return {
        ...state,
        addLoading: false,
        addError: payload
      }

    case preferredLaneTypes.UPDATE_PREFERRED_LANE:
      return {
        ...state,
        editLoading: true,
        editError: ''
      }

    case preferredLaneTypes.UPDATE_PREFERRED_LANE_SUCCESS: {
      const updatedLane = {
        ...payload,
        origin: {
          ...payload.origin,
          state_code: payload.origin.state_id || payload.origin.state_code
        },
        destination: {
          ...payload.destination,
          state_code: payload.destination.state_id || payload.destination.state_code
        }
      }
      const newLanes = state.preferredLanes.map(lane => lane.lane_id === payload.lane_id ? updatedLane : lane)
      return {
        ...state,
        preferredLanes: newLanes,
        editLoading: false,
        editError: ''
      }
    }

    case preferredLaneTypes.UPDATE_PREFERRED_LANE_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: payload
      }

    case preferredLaneTypes.DELETE_PREFERRED_LANE:
      return {
        ...state,
        deleteLoading: true,
        deleteError: ''
      }

    case preferredLaneTypes.DELETE_PREFERRED_LANE_SUCCESS: {
      const newLanes = state.preferredLanes.filter(lane => lane.lane_id !== payload)
      return {
        ...state,
        preferredLanes: newLanes,
        deleteLoading: false,
        deleteError: ''
      }
    }

    case preferredLaneTypes.DELETE_PREFERRED_LANE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: payload
      }

    default:
      return state
  }
}
